function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import * as Utility from "../commons/Utility";
import * as Api from "../ajax/SessionApi";
import IntlMessage from '../commons/Intl';
import { Label, Errors, Action, Portal } from '../commons/IntlMessages';
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language); // ポータル追加モーダル

/**
 * モード
 */

export var Mode;

(function (Mode) {
  /**
   * なし
   */
  Mode[Mode["None"] = 0] = "None";
  /**
   * 追加
   */

  Mode[Mode["Add"] = 1] = "Add";
})(Mode || (Mode = {}));
/**
 * 会議ポータル追加モーダルコンポーネント
 */


var SessionPortalModalComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(SessionPortalModalComponent, _React$Component);

  var _super = _createSuper(SessionPortalModalComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function SessionPortalModalComponent(props) {
    var _this;

    _classCallCheck(this, SessionPortalModalComponent);

    _this = _super.call(this, props);

    switch (props.mode) {
      case Mode.Add:
        _this.state = {
          Modal: null,
          PortalList: [],
          SessionId: null,
          SessionName: "",
          PrivateModeOnly: false,
          ErrorMessages: []
        };
        break;

      default:
        throw Error;
    }

    Api.GetSessionPortalList(_this.props.sessionId, function (data) {
      _this.setState({
        PortalList: data.PortalList
      });
    });
    return _this;
  }
  /**
   * 会議ポータルを更新します。
   *
   * @param e イベント
   */


  _createClass(SessionPortalModalComponent, [{
    key: "updatePortal",
    value: function updatePortal(e) {
      if (e.target.value == "") {
        this.setState({
          SessionId: null,
          SessionName: ""
        });
      } else {
        this.setState({
          SessionId: parseInt(e.target.value),
          SessionName: e.target.options[e.target.selectedIndex].label.slice(13)
        });
      }
    }
    /**
     * 強制プライベートモードフラグを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updatePrivateModeOnly",
    value: function updatePrivateModeOnly(e) {
      this.setState({
        PrivateModeOnly: e.target.checked
      });
    }
    /**
     * 「登録」ボタン押下時の処理を行います。
     */

  }, {
    key: "onEntry",
    value: function onEntry() {
      if (this.state.Modal == null) {
        throw Error();
      }

      var form = $("#MainForm");
      $.validator.unobtrusive.parse(form);
      form.validate();

      if (form.valid()) {
        this.state.ErrorMessages.length = 0;

        if (this.state.ErrorMessages.length != 0) {
          this.setState({
            ErrorMessages: this.state.ErrorMessages
          });
          return;
        }

        var materialFileName = this.state.SessionId + ".Portal";
        this.props.onEntry(this.props.sessionId, materialFileName, this.state.PrivateModeOnly);
        this.state.Modal.modal('hide');
      }
    }
    /**
     * 「戻る」ボタン押下時の処理を行います。
     */

  }, {
    key: "onBack",
    value: function onBack() {
      if (this.state.Modal == null) {
        throw Error();
      }

      this.props.onBack();
      this.state.Modal.modal('hide');
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var modal = $('#PortalDialogModal');
      this.setState({
        Modal: modal
      });
      modal.modal({
        backdrop: 'static',
        keyboard: false
      }); // ポップアップが完全に非表示になった時のイベント。

      modal.on("hidden.bs.modal", function () {
        _this2.props.onHidden();
      });
      $("form").removeData("validator").removeData("unobtrusiveValidation").off("submit.validate click.validate focusin.validate focusout.validate keyup.validate invalid-form.validate");
      $.validator.unobtrusive.parse("form");
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "PortalDialogModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, this.state.ErrorMessages.length > 0 && /*#__PURE__*/React.createElement("div", {
        className: "validation-summary-errors alert alert-danger"
      }, /*#__PURE__*/React.createElement("ul", null, this.state.ErrorMessages.map(function (x, i) {
        return /*#__PURE__*/React.createElement("li", {
          key: i
        }, x);
      }))), /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "48",
        height: "40",
        src: "/assets/img/Icon_Portal.svg"
      }), /*#__PURE__*/React.createElement("h3", null, intl.format(Portal.Title))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-9 mx-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label",
        htmlFor: "Destination"
      }, intl.format(Label.Destination)), /*#__PURE__*/React.createElement("div", {
        className: "col-9"
      }, /*#__PURE__*/React.createElement("select", {
        className: "form-control",
        id: "Destination",
        name: "Destination",
        "data-val": "true",
        "data-val-nowhitespace": intl.format(Errors.InputRequired),
        onChange: function onChange(e) {
          return _this3.updatePortal(e);
        },
        value: Utility.NullNumberToBlank(this.state.SessionId),
        tabIndex: 100
      }, /*#__PURE__*/React.createElement("option", {
        value: ""
      }, intl.format(Portal.DesticationOptionsNone)), this.state.PortalList && this.state.PortalList.map(function (x, _i) {
        return /*#__PURE__*/React.createElement("option", {
          value: x.SessionId
        }, Utility.ToMoment(x.StartDateTime).format("YYYY/MM/DD"), " - ", x.SessionName);
      })), /*#__PURE__*/React.createElement("span", {
        className: "text-danger",
        "data-valmsg-for": "Destination",
        "data-valmsg-replace": "true",
        style: {
          fontSize: "16px"
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-group row"
      }, /*#__PURE__*/React.createElement("label", {
        className: "col-3 col-form-label"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-7"
      }, /*#__PURE__*/React.createElement("div", {
        className: "checkbox icheck-asbestos"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "privateModeOnly",
        name: "privateModeOnly",
        onChange: this.updatePrivateModeOnly.bind(this),
        checked: this.state.PrivateModeOnly
      }), /*#__PURE__*/React.createElement("label", {
        htmlFor: "privateModeOnly"
      }, intl.format(Portal.PrivateModeOnly)))))))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-default",
        onClick: this.onBack.bind(this),
        tabIndex: -1
      }, intl.format(Action.Back)), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: this.onEntry.bind(this),
        tabIndex: -1
      }, intl.format(Action.Entry))))));
    }
  }]);

  return SessionPortalModalComponent;
}(React.Component);

export { SessionPortalModalComponent as default };